// tslint:disable no-unbound-method
export default () => {
  // requestAnimationFrame: IE10+
  return typeof window.requestAnimationFrame !== 'function';
};



// WEBPACK FOOTER //
// (webpack)-remove-block-loader??ref--5-0!./src/browser/isOutOfDate.tsx